import { useQuery } from "@tanstack/react-query";

import { ListIntegrationHistoryFilters, UseListIntegrationHistoryQueryOptions } from "./types";
import { getIntegrationHistoryService } from "./service";

export const listIntegrationHistoryQueryKey = ["v1/integration_history_admin"];

export function useListIntegrationHistoryQuery(
  filters: ListIntegrationHistoryFilters,
  options?: UseListIntegrationHistoryQueryOptions
) {
  const queryKey = listIntegrationHistoryQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getIntegrationHistoryService(filters),
    ...options,
  });
}
